module.exports = __webpack_public_path__ + "static/img/ipa.7de0831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/ipa.png
// module id = WfLb
// module chunks = 53